import { useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import { Icon, IconifyIcon } from '@iconify/react';
import cx from 'classnames';
import TextError from './TextError';
import PasswordVisibilityToggle from '../PasswordVisibilityToggle';
import styles from './FormikStyles.module.scss';

interface Props {
  bottomborder?: boolean;
  className?: string;
  fullborder?: boolean;
  icon?: IconifyIcon;
  label: string;
  name: string;
  isrequired?: boolean;
  type?: string;
  showPasswordToggle?: boolean;
}

function Input(props: Props): JSX.Element {
  const { label, name, type, showPasswordToggle, ...rest } = props;
  // Reveal-password state is intentionally local and not persisted, so the
  // password is always hidden again on the next visit.
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordToggle = Boolean(showPasswordToggle) && type === 'password';
  const effectiveType = isPasswordToggle && showPassword ? 'text' : type;

  return (
    <div className={cx(styles.formControl, props.className)}>
      {props.label && (
        <label
          htmlFor={name}
          className={cx({
            [`${styles.required}`]: props.isrequired,
          })}
        >
          {props.icon && <Icon icon={props.icon} />}
          {label}
        </label>
      )}
      {props.isrequired && !props.label && <span className={styles.asterisk}>*</span>}
      <div className={styles.inputWrapper}>
        <Field
          id={name}
          name={name}
          type={effectiveType}
          {...rest}
          className={cx({
            [`${styles.fullBorder}`]: props.fullborder,
            [`${styles.bottomBorder}`]: props.bottomborder,
            [`${styles.leftPadding}`]: props.label,
            [`${styles.withToggle}`]: isPasswordToggle,
          })}
        />
        {isPasswordToggle && (
          <PasswordVisibilityToggle visible={showPassword} onToggle={() => setShowPassword((prev) => !prev)} />
        )}
      </div>
      <div className={styles.errorHintContainer}>
        <ErrorMessage name={name} component={TextError} />
      </div>
    </div>
  );
}

export default Input;
